module.exports = __webpack_public_path__ + "images/feature/0717_cal_rp_3-094c1ce6e49fbb414a2e337dbc87b02a.jpg";